import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import Particles from './fancy/Particles';
import memoji from '../assets/memoji.png';
import hiImage from '../assets/hi.png';
import TypeText from './fancy/TypeText';

const heading = "Hello, I'm Rachel";
const subheading = "I apply machine learning to physical engineering systems, especially manufacturing, sensing, imaging, and automation problems.";
const charDelay = 0.06;
const headingTime = heading.length * charDelay;

export function Hero() {
  const heroRef = useRef(null);
  const [isHi, setIsHi] = useState(false);
  const [isBouncing, setIsBouncing] = useState(false);

  const handleMemojiClick = () => {
    setIsHi(!isHi);
    setIsBouncing(true);
    setTimeout(() => setIsBouncing(false), 600);
  };

  const scrollToSkills = () => {
    const el = document.querySelector('#skills');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section
      id="hero"
      ref={heroRef}
      className="relative overflow-hidden min-h-[calc(100vh-4rem)] flex items-center justify-center text-center"
    >
      {/* Scoped particles behind content */}
      <Particles scopeRef={heroRef} />

      <div className="container mx-auto px-4 relative z-10">
        <motion.img
          src={isHi ? hiImage : memoji}
          alt="Rachel's Memoji"
          className="mx-auto w-48 h-48 mb-6 rounded-full cursor-pointer"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ 
            scale: isBouncing ? [1, 1.3, 0.9, 1.1, 1] : 1, 
            opacity: 1,
            rotate: isBouncing ? [0, -10, 10, -5, 0] : 0
          }}
          transition={{ 
            scale: { duration: 0.6 },
            rotate: { duration: 0.6 },
            opacity: { duration: 0.8, ease: 'easeOut' }
          }}
          onClick={handleMemojiClick}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        />

        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
          <TypeText text={heading} charDelay={charDelay} />
        </h1>

        <h2 className="text-xl mb-8 text-gray-700 dark:text-gray-300">
          <TypeText text={subheading} charDelay={charDelay} startDelay={headingTime} />
        </h2>

        <motion.button
          type="button"
          onClick={scrollToSkills}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && scrollToSkills()}
          aria-label="Scroll to Skills"
          className="mx-auto text-2xl text-indigo-500 dark:text-indigo-300 cursor-pointer select-none focus:outline-none focus:ring-2 focus:ring-indigo-400 rounded-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, y: [0, -10, 0] }}
          transition={{
            delay: headingTime + subheading.length * charDelay,
            duration: 3, repeat: Infinity, ease: 'easeInOut'
          }}
        >
          ↓
        </motion.button>
      </div>
    </section>
  );
}
